import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, FormHelperText, Stack, TextField } from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as Yup from 'yup';

import type { DiscoverType } from '@/types/Profile/DiscoverType';

import CustomTextMask from '../ui/CustomTextMask';
import Loader from '../ui/Loader';

interface Props {
  buttontext: string;
  helptext: string;
}

export default function DiscoverEin(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const validationSchema = Yup.object().shape(
    {
      EIN: Yup.string()
        .required('EIN is required')
        .matches(/^\d{2}-?\d{7}$/, 'Please enter a valid EIN'),
    },
    [
      // Add Cyclic deps here because when require itself
    ]
  );

  const { handleSubmit, control } = useForm<DiscoverType>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: {
      EIN: '',
    },
  });

  const onSubmit = async (data: DiscoverType) => {
    const redirectUrl: any = `/tax-exempt/organization/?ein=${data.EIN}`;
    router.push(redirectUrl);
    setIsLoading(true);
  };
  return (
    <>
      <Loader isLoading={isLoading} />
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        component="form"
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        justifyContent="center"
      >
        <Box>
          <Controller
            name="EIN"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                size="medium"
                id="EIN"
                label="Enter Organization EIN to Auto-Fill Form"
                variant="outlined"
                color="secondary"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={error ? error.message : null}
                sx={{ mb: 0, minWidth: { xs: 343, sm: 434 } }}
                className={value ? 'prefilled' : 'mandatory'}
                type="text"
                slotProps={{
                  htmlInput: {
                    maxLength: 10,
                  },
                  input: {
                    inputComponent: CustomTextMask as any,
                    inputProps: {
                      mask: '00-0000000',
                      pattern: '[0-9]*',
                      inputMode: 'numeric',
                    },
                  },
                }}
                fullWidth
              />
            )}
          />
          <FormHelperText
            sx={{
              mx: { sm: 1 },
              textAlign: { xs: 'left', sm: 'left' },
              color: '#14181f',
              fontStyle: 'italic',
              fontSize: { xs: 10, sm: 12, md: 11, lg: 12 },
              lineHeight: 1.3,
            }}
          >
            {props.helptext}
          </FormHelperText>
        </Box>
        <Box sx={{ minWidth: { xs: '100%', sm: 188 }, textAlign: 'center' }}>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            size="large"
            fullWidth
            // className="btn-primary"
            startIcon={
              <SearchIcon
                sx={{
                  fontSize: {
                    xs: '24px !important',
                    sm: '28px !important',
                  },
                }}
              />
            }
            sx={{
              mx: 'auto',
              mb: 0,
              mt: 0.75,
              boxShadow: 'none',
              textTransform: 'none',
              borderRadius: 2,
              width: { xs: 270, sm: '100%' },
              textAlign: 'center',
              justifyContent: 'center',
            }}
          >
            {props.buttontext}
          </Button>
        </Box>
      </Stack>
    </>
  );
}
